import { render, staticRenderFns } from "./ShowEdit.vue?vue&type=template&id=662ef53b&scoped=true&lang=pug&"
import script from "./ShowEdit.vue?vue&type=script&lang=js&"
export * from "./ShowEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662ef53b",
  null
  
)

export default component.exports